import React from "react";
import RailServicePage from "./RailServicePage";

export default function TrainSupport247() {
  return (
    <RailServicePage
      eyebrow="24/7 Train Support"
      title="24/7 train booking support"
      description="Get live help for train searches, route planning, booking changes, cancellations, and station questions."
      icon="support"
      highlights={[
        {
          title: "Live rail assistance",
          text: "Talk with a support advisor when you need help comparing train options or understanding ticket rules.",
        },
        {
          title: "Trip change help",
          text: "Get guidance for date changes, schedule updates, passenger details, and cancellation questions.",
        },
      ]}
      steps={[
        "Call our support line for rail booking help.",
        "Share your route, date, passenger count, and travel preferences.",
        "Get guidance on available options and next steps.",
      ]}
    />
  );
}
